export enum StorageKeys {
  // Auth
  AUTH_TOKEN = "rusha:token",
  USER = "rusha:user",
  OKTA_AUTH = "rusha:oktaAuth",

  // Organization / Project selection
  SELECTED_ORGANIZATION = "rusha:selectedOrganization",
  RECENT_ORGANIZATIONS = "rusha:recentOrganizations",
  RECENT_PROJECTS = "rusha:recentProjects",
  SELECTED_PROJECT = "rusha:selectedProject",
  /** @deprecated No longer written to. Org alias is derived from the JWT via OrgSessionManager.getOrgAlias(). */
  CURRENT_ORG_ALIAS = "rusha:currentOrgAlias",

  // Preferences
  USER_PREFERENCES = "rusha:user_preferences",
  THEME_MODE = "rusha:theme_mode",
  LANGUAGE = "rusha:language",
  FEATURE_FLAGS = "rusha:feature_flags",
}

/** Org-scoped project key — prevents cross-org contamination. */
export const getProjectStorageKey = (orgAlias: string): string =>
  `rusha:${orgAlias}:selected_project`;

export const RUSHA_STORAGE_PREFIX = "rusha:";
